<template>
<v-data-table :headers="headers" :items="filteredItems" :search="search">
    <template v-slot:items="{ item }">
        <td>{{ item.ProductCategoryNames.join(",") }}</td>
        <td>{{ item.Minimum }}</td>
        <td>{{ item.Maximum }}</td>
        <td>{{ item.Interval }}</td>
        <td>{{ item.Threshold }}</td>
        <td>{{ item.IsActive ? 'Active' : 'Inactive' }}</td>
        <td>
            <v-btn color="primary" block @click="$emit('edit', item)">
                <span>Edit</span>
            </v-btn>
        </td>
    </template>
</v-data-table>
</template>

<script>
export default {
    props: {
        filteredItems: {
            type: Array,
            required: true
        },
        search: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headers: [
                {
                    text: "Product Category",
                    value: "ProductCategoryNames",
                    sortable: true
                },
                {
                    text: "Minimum",
                    value: "Minimum",
                    sortable: true
                },
                {
                    text: "Maximum",
                    value: "Maximum",
                    sortable: true
                },
                {
                    text: "Interval",
                    value: "Interval",
                    sortable: true
                },
                {
                    text: "Threshold",
                    value: "Threshold",
                    sortable: true
                },
                {
                    text: "Active Status",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "ScoutingScoreScaleID",
                    sortable: false
                }
            ]
        }
    }
}
</script>
